import actions from "actions";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import {
  clearStudyGroups,
  getStudygroupsInfinite,
} from "../../actions/studygroups";
import { noImagePlaceholder } from "../../constants/baseConst";
import constants from "constants";

const { API_CURRENT_WEBINARS } = constants;

const apiLoadWebinars = (params) =>
  axios.get(API_CURRENT_WEBINARS, {
    params: {
      ...params,
    },
  });

const loadCurrentWebinars = async (group_id) => {
  const { data } = await apiLoadWebinars({
    page: 1,
    per_page: 5,
    group_id,
  });

  const hasCurrentWebinars = Boolean(data.count);

  return hasCurrentWebinars;
};

class UserStudyGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studygroup_ids: [],
      page: props.page || 1,
      query: {
        title: "",
        per_page: 6,
      },
    };
  }

  componentDidMount() {
    this.loadStudyGroups();
  }

  componentWillUnmount() {
    this.props.clearStudyGroups();
  }

  loadStudyGroups = () =>
    this.props.loadStudygroups(this.state.query, this.state.page);

  handleLoadMore = () => {
    this.setState(
      {
        page: this.state.page + 1,
      },
      this.loadStudyGroups
    );
  };

  render() {
    const { studygroups, page, total_pages } = this.props;

    return (
      <div style={{ width: "80%", margin: "auto" }}>
        {!studygroups.length && (
          <h5
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div>
              MedCafe's latest feature, MedMeetings, allows members to create
              their own closed groups to run meetings
            </div>
            <div>
              Invite members, host webinars, distribute CPD certificates, and
              publish course resources for members in your own MedMeetings
              groups.
            </div>
            <div style={{ marginTop: "60px" }}>
              You are not currently a member of any MedMeetings groups
            </div>
            <div>
              If you would like to join a MedMeetings group, or create your own
              MedMeetings group, please email{" "}
              <a href="mailto:support@medcafe.ie">support@medcafe.ie</a>
            </div>
          </h5>
        )}
        {!!studygroups.length && (
          <div className="group-card-list">
            {studygroups.map((group) => (
              <UserStudyGroupsCard key={group.id} group={group} />
            ))}
          </div>
        )}
        {page !== total_pages && (
          <a className="more_item" onClick={this.handleLoadMore}>
            Load more
          </a>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <iframe
            src={
              "https://player.vimeo.com/video/1056434309?h=32bed87ec2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            }
            width="700"
            height="500"
            webkitallowfullscreen
            mozallowfullscreen
            allowFullScreen
            frameBorder="0"
          ></iframe>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroups: state.studygroups.studygroups.values,
  query: state.studygroups.studygroups.query,
  page: state.studygroups.studygroups.page,
  total_pages: state.studygroups.studygroups.total_pages,
  count: state.studygroups.studygroups.count,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudygroups: (page, query) =>
    dispatch(getStudygroupsInfinite(page, query)),
  clearStudyGroups: () => dispatch(clearStudyGroups()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserStudyGroups);

class UserStudyGroupsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasCurrentWebinars: false,
    };
  }

  componentDidMount() {
    (async () => {
      const hasCurrentWebinars = await loadCurrentWebinars(this.props.group.id);
      this.setState({ hasCurrentWebinars });
    })();
  }

  render() {
    const { hasCurrentWebinars } = this.state;
    const { group } = this.props;

    const { id, title, logo_url } = group;

    const link = hasCurrentWebinars
      ? `/groups/${id}/webinars/current`
      : `/groups/${id}/webinars/upcoming`;

    return (
      <div className="group-card" key={id}>
        <img
          src={logo_url || noImagePlaceholder}
          className="group-card-image"
        />
        <div className="group-card-title">{title}</div>
        <div className="group-card-button-group">
          <Link to={link}>
            <button className="group-card-button">Enter</button>
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/StudyGroups/index.jsx